export const availValidationData = (payload) => {
  let errors = []

  if (!payload?.provider_id)
  errors.push({
    type: 'provider',
    message: 'Proveedor es requerido'
  })

  if (!payload?.destination?._id)
    errors.push({
      type: 'keyword',
      message: 'Destino es requerido'
    })
  if (!payload?.countryCode || !payload?.country)
    errors.push({
      type: 'nationality',
      message: 'Nacionalidad es requerida'
    })
  if (!payload?.start)
    errors.push({
      type: 'checking',
      message: 'Dia estimado de la actividad es requerido'
    })

    if (!payload?.totalNumberOfPeople)
      errors.push({
        type: 'rooms',
        message: 'Número de personas es requerido'
      })
   

  return {
    errors: errors.length ? true : false,
    data: errors
  }
}

export const reserveValidationData = (payload) => {
  let errors = []

  if (!payload?.bookingCodes.length)
    errors.push({
      type: 'bookingCode',
      message: 'Código del evento no hallado'
    })
  if (!payload?.countryCode || !payload?.country)
    errors.push({
      type: 'nationality',
      message: 'Nacionalidad es requerida'
    })
  if (!payload?.start || !payload?.end)
    errors.push({
      type: 'checking',
      message: 'Checking es requerido'
    })

  if (!payload?.companions.length)
    errors.push({
      type: 'companions',
      message: 'Número de personas es requerido'
    })

  return {
    errors: errors.length ? true : false,
    data: errors
  }
}
